import { Fragment } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function PolicySectionControllerInfo({
  t,
  siteConfig,
}: {
  t: CookieConsentTranslator
  siteConfig: SiteConfig
}) {
  const companyName =
    siteConfig.companyName ||
    siteConfig.policyContext['companyName'] ||
    siteConfig.coachName

  return (
    <Fragment>
      <Paragraph>{t('policyControllerParagraph', { companyName })}</Paragraph>
      <WebsiteUrl siteConfig={siteConfig} t={t} />
      <Paragraph>{t('policyYouParagraph')}</Paragraph>
      <PrivacyPolicyUrl privacyPolicyUrl={siteConfig.cookiePolicyUrl} t={t} />
    </Fragment>
  )
}

function WebsiteUrl({
  siteConfig,
  t,
}: {
  siteConfig: SiteConfig
  t: CookieConsentTranslator
}) {
  if (!siteConfig.domain) {
    return null
  }

  return (
    <Paragraph>
      {t('policyWebsitePrefix')}
      <a href={siteConfig.domain} target="_blank" rel="noopener noreferrer">
        {siteConfig.domain}
      </a>
      {t('policyWebsiteSuffix')}
    </Paragraph>
  )
}

function PrivacyPolicyUrl({
  privacyPolicyUrl,
  t,
}: {
  privacyPolicyUrl: string
  t: CookieConsentTranslator
}) {
  if (!privacyPolicyUrl) {
    return null
  }

  return (
    <Paragraph>
      {t('policyPrivacyPrefix')}
      <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
        {privacyPolicyUrl}
      </a>
      .
    </Paragraph>
  )
}
